module.exports = __webpack_public_path__ + "img/business.f4cd62f8.svg";